<template>
  <div class="bg-white px-4 py-3 flex justify-between border-t border-gray-200 sm:px-6">
    <div class="flex-1 flex justify-between sm:hidden">
      <a
        href="#"
        class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
      >
        Previous
      </a>
      <a
        href="#"
        class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
      >
        Next
      </a>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Viser
          <span class="font-medium">{{ model.from }}</span>
          til
          <span class="font-medium">{{ model.to }}</span>
          av
          <span class="font-medium">{{ model.total }}</span>
          resultater
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <template v-for="link in model.links">
            <span
              v-if="link.url === null"
              class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"
              v-html="link.label"
            />
            <template v-else>
              <Link
                v-if="link.active"
                :href="link.url"
                aria-current="page"
                class="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                v-html="link.label"
              />
              <Link
                v-else
                :href="link.url"
                class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 hidden md:inline-flex relative items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                v-html="link.label"
              />
            </template>
          </template>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue3';

export default {
    components: {Link},
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
};
</script>
